




import Vue from 'vue';
import { EditorState, EditorView, basicSetup } from '@codemirror/basic-setup';
import { ViewPlugin, ViewUpdate } from '@codemirror/view';
import { html } from '@codemirror/lang-html';

export default Vue.extend({
  name: 'editor',
  data() {
    return {
      view: (null as null | EditorView),
    };
  },
  props: {
    code: String,
    value: {
      type: String,
      default: '',
    },
  },
  methods: {
    initialize() {
      const updateValue = (doc: string) => this.$emit('input', doc);
      if (this.$refs.body instanceof Element) {
        this.view = new EditorView({
          state: EditorState.create({
            doc: this.value,
            extensions: [
              ViewPlugin.fromClass(class {
                update(update: ViewUpdate) {
                  if (update.docChanged) {
                    updateValue(update.state.doc.toString());
                  }
                }
              }),
              basicSetup,
              html(),
            ],
          }),
          parent: this.$refs.body,
        });
      }
    },
    // update() {
    //   if (this.view) {
    //     this.view.state.doc.;
    //   }
    // },
    destroy() {
      if (this.view) {
        this.view.destroy();
      }
    },
  },
  mounted() {
    this.initialize();
  },
  beforeDestroy() {
    this.destroy();
  },
});
